import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { CoinComponent } from '../Gamification/CoinComponent'

const StyledModal = styled(Modal)`
  color: #505c7c;
  .modal-content {
    padding: 0 8px;
    border: none;
    border-radius: 20px;
  }
  .modal-header {
    border: none;
  }
  .close {
    border: none;
    font-size: 24px;
    background: transparent;
  }
  .file-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    p {
      word-break: break-all;
    }
    button {
      background: transparent;
      border: none;
      color: #FFAD2C;
    }
  }
`

export default function DownloadModal({ mission, files, downloadOpen, setDownloadOpen }) {
  return (
    <StyledModal
      show={downloadOpen}
      onHide={()=>setDownloadOpen(false)}
      aria-labelledby="download-modal"
      centered
    >
      { mission.mission_type === "download_pdf" && <CoinComponent mission={mission} />}
      <Modal.Header closeButton>
        <h6 id="download-modal">Select file(s) to preview</h6>
      </Modal.Header>
      <Modal.Body>
        {
          files.map(file=>(
            <div key={file.filename} className="file-container">
              <p>{file.filename}</p>
              <a href={file.url} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <button>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F83636" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="#F83636" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline stroke="#F83636" points="7 10 12 15 17 10"></polyline>
                    <line stroke="#F83636" x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                </button>
              </a>
            </div>
          ))
        }
      </Modal.Body>
    </StyledModal>
  )
}
